<template>
    <v-flex>
        <div class="elevation-3">
    
            <div class="noTableHeader">
                <v-dialog persistent v-model="modal" max-width="500px">
                    <v-btn slot="activator" color="#f8ac4a" dark class="mb-2">
                        <v-icon class="buttonIconText" color="white">playlist_add</v-icon> Nova {{name}}</v-btn>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-form ref="form" v-on:submit.prevent>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 sm12 md12>
                                            <label class="label-modal">Nome</label>
                                            <v-text-field color="#f8ac4a" :autofocus="true" :rules="defaultRules" v-model="editedItem.nome"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <label class="label-modal">Descrição</label>
                                            <v-textarea color="#f8ac4a" :rules="defaultRules" auto-grow :rows="1" v-model="editedItem.descricao"></v-textarea>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <label class="label-modal">Objetivo</label>
                                            <v-autocomplete color="#f8ac4a" :items="getObjetivos" v-model="editedItem.id_objetivo" item-text="nome" item-value="id_objetivo" :rules="defaultRules"></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="#f8ac4a" flat @click.native="close">Cancelar</v-btn>
                                <v-btn color="#f8ac4a" flat @click.native="save">Guardar</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
    
                <v-text-field color="#f8ac4a" class="searchTable" v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
            </div>
    
            <v-dialog persistent v-model="deleteM" max-width="390">
                <v-card>
                    <v-card-title class="headline" style="margin-left: 0px !important;">Apagar {{name}}</v-card-title>
                    <v-card-text>De certeza que quer apagar esta {{name}}?</v-card-text>
                    <v-card-actions style="margin-top: 0px !important;">
                        <v-spacer></v-spacer>
                        <v-btn color="#f8ac4a" flat="flat" @click.native="close">Cancelar</v-btn>
                        <v-btn color="#f8ac4a" flat="flat" @click.native="save">Apagar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    
            <v-data-table :headers="headers" :items="DATA" :search="search" :loading="loading" item-key="id" :disable-initial-sort="true" :rows-per-page-items='[10,25,50,{"text":"Todos","value":-1}]' rows-per-page-text="Itens por página:">
                <template slot="items" slot-scope="props">
                        <td @click="editItem(props.item, true)" style="width: 15%;" class="textLeft">{{ props.item.id_medida }}</td>
                        <td @click="editItem(props.item, true)" style="width: 30%" class="textLeft">{{ props.item.nome }} - {{ props.item.descricao }}</td>
                        <td @click="editItem(props.item, true)" style="width: 30%" class="textCenter">{{ getObjetivoById(props.item.id_objetivo).nome }}</td>
                        <td class=" px-0 textTable textCenter">
                        	<v-btn icon class="mx-0" @click="editItem(props.item, true)">
                                <v-icon color="light-green darken-1">edit</v-icon>
                            </v-btn>
                            <v-btn icon class="mx-0" @click="editItem(props.item, false)">
                                <v-icon color="red lighten-1">delete</v-icon>
                            </v-btn>
                        </td>
</template>

<template class="alertTable" slot="no-data">
    <v-alert :value="true" icon="warning">
        De momento não há nada a apresentar! :(
    </v-alert>
</template>
            </v-data-table>
            
        </div>
    </v-flex>
</template>

<script>

import { mapState, mapGetters, mapActions } from "vuex";
    const cName = {
        upper: "Medida",
        lower: "a medida!"
    };
    
    export default {
        data: () => ({
            table: 'medidas',
            name: 'medida',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [
            {
                text: "#",
                align: "left",
                sortable: true,
                value: "id_medida"
            },
            {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            },
            {
                text: "Objetivo",
                align: "center",
                sortable: true,
                value: "id_objetivo"
            },
            {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }
            ],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_medida: 0,
                nome: "",
                descricao: "",
                id_objetivo: 0
            },
            defaultItem: {
                id_medida: 0,
                nome: "",
                descricao: "",
                id_objetivo: 0
            },
            messages: {
                add: {
                    success: cName.upper + " criada com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterada com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminada com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        }),
    
        computed: {
            ...mapGetters({
                getAll: 'medidas/getAll',
                getObjetivos: 'objetivos/getAll',
                getObjetivoById: 'objetivos/getById'
            }),
            formTitle() {
                return this.editedIndex === -1 ? "Nova "+this.name : "Editar "+this.name;
            }
        },
    
        watch: {
            modal(val) {
                val || this.close()
            },
            deleteM(val) {
                val || this.close()
            },
            getAll(val) {
                this.initialize()
            }
        },
    
        created() {
            this.defaultRules = [v => !!v || this.$requiredField + ''];
            this.initialize();
       },
        mounted() {
            
        },
        methods: {
            toast(type, message) {
                if (type == "success") {
                    return iziToast.show({
                        title: "SUCESSO",
                        color: "green",
                        timeout: this.$toastTimeout,
                        message: message,
                        position: this.$toastPosition
                    });
                } else {
                    return iziToast.show({
                        title: "AVISO",
                        color: "red",
                        timeout: this.$toastTimeout,
                        message: message,
                        position: this.$toastPosition
                    });
                }
            },

            initialize() {
                this.loading = true;
                this.DATA = this.getAll;
                this.loading = false;
            },
    
            editItem(item, dialog) {
                this.editedIndex = this.DATA.indexOf(item);
                this.editedItem = Object.assign({}, item);

                if (dialog) this.modal = true;
                else this.deleteM = true;
            },

    
            delete() {
                if(!this.editedItem.id_medida) return;

                this.$store
                    .dispatch(this.table+"/delete", {id: this.editedItem.id_medida})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.delete.success); this.initialize(); }
                        else this.toast('error', this.messages.delete.error);
                            
                        this.deleteM = false;
                    });
            },
    
            close() {
                this.modal = this.deleteM = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                    
                    this.$refs.form.reset();
                }, 110);
            },
    
            save() {
                
                if(this.deleteM) {this.delete(); return;}

                if(!this.$refs.form.validate()) return;

                if(this.editedIndex == -1) {
                    this.$store
                    .dispatch(this.table+"/insert", {nome: this.editedItem.nome, id_objetivo: this.editedItem.id_objetivo, descricao: this.editedItem.descricao})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.add.success); this.initialize(); }
                        else this.toast('error', this.messages.add.error);
                            
                        this.modal = false;
                    });
                }
                else {
                    this.$store
                    .dispatch(this.table+"/update", {id: this.editedItem.id_medida, nome: this.editedItem.nome, id_objetivo: this.editedItem.id_objetivo, descricao: this.editedItem.descricao})
                    .then((res) => {
                        if(res) { this.toast('success', this.messages.update.success); this.initialize(); }
                        else this.toast('error', this.messages.update.error);
                            
                        this.modal = false;
                    });
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/tables/Table_Medidas.vue